/**
 * Belcopia Upsell System
 * - Product page: Quick-add buttons for upsell accessories
 * - Cart drawer: Dynamic accessory suggestions based on cart contents
 */
(function() {
  'use strict';

  // ── Product Page: Quick Add ───────────────────────────────────────────────

  function initProductPageUpsells() {
    // Variant picker on a card (helmet colours): the button adds whatever the picker shows.
    document.addEventListener('change', function(evt) {
      var sel = evt.target;
      if (!sel.classList || !sel.classList.contains('belcopia-upsells__variant')) return;
      var card = sel.closest('.belcopia-upsells__item');
      if (!card) return;
      var btn = card.querySelector('.belcopia-upsells__add-btn');
      if (btn) btn.setAttribute('data-variant-id', sel.value);
      var opt = sel.options[sel.selectedIndex];
      var now = card.querySelector('.belcopia-upsells__price--current');
      if (now && opt && opt.getAttribute('data-price')) now.textContent = opt.getAttribute('data-price');
    });

    document.addEventListener('click', function(evt) {
      var btn = evt.target.closest('.belcopia-upsells__add-btn');
      if (!btn) return;

      evt.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: 'form_type=product&id=' + variantId + '&quantity=1'
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        btn.textContent = 'Added!';
        btn.classList.add('belcopia-upsells__add-btn--added');

        // Dispatch event so cart drawer opens and updates
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data, addToCartBtn: btn }
        }));

        // Reset button after 2s
        setTimeout(function() {
          btn.textContent = '+ Add to Cart';
          btn.classList.remove('belcopia-upsells__add-btn--added');
          btn.disabled = false;
        }, 2000);
      })
      .catch(function() {
        btn.textContent = 'Error';
        btn.disabled = false;
        setTimeout(function() {
          btn.textContent = '+ Add to Cart';
        }, 2000);
      });
    });
  }

  // ── Cart Drawer: Dynamic Upsells ──────────────────────────────────────────

  var drawerUpsellCache = {};

  function getCartItems() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(r) { return r.json(); });
  }

  function getProductData(handle) {
    if (drawerUpsellCache[handle]) {
      return Promise.resolve(drawerUpsellCache[handle]);
    }
    return fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        drawerUpsellCache[handle] = data.product;
        return data.product;
      })
      .catch(function() { return null; });
  }

  function getUpsellHandles(handle) {
    return getProductData(handle).then(function(product) {
      if (!product || !product.metafields) return [];
      // Storefront product.json doesn't expose metafields, so we use
      // the section rendering approach or pre-embedded data.
      // Fallback: fetch the product page and parse data attributes.
      return [];
    });
  }

  function renderCartDrawerUpsells(upsellProducts, cartHandles) {
    var container = document.getElementById('CartDrawerUpsells');
    if (!container) return;

    // Filter out items already in cart (availability pre-checked by upsell builder)
    var filtered = upsellProducts.filter(function(p) {
      return p && cartHandles.indexOf(p.handle) === -1;
    });

    if (filtered.length === 0) {
      container.innerHTML = '';
      return;
    }

    // Show max 2 in drawer
    filtered = filtered.slice(0, 2);

    var html = '<div class="cart-upsells">';
    html += '<div class="cart-upsells__header">You May Also Need</div>';
    html += '<div class="cart-upsells__items">';

    filtered.forEach(function(product) {
      var variant = product.variants.filter(function(v) { return v.available !== false; })[0] || product.variants[0];
      var imageUrl = '';
      if (product.featured_image) {
        imageUrl = product.featured_image;
      } else if (product.images && product.images.length > 0) {
        imageUrl = product.images[0].src || product.images[0];
      }
      // Resize image
      if (imageUrl && imageUrl.indexOf('cdn.shopify.com') > -1) {
        imageUrl = imageUrl.replace(/(\.\w+)\?/, '_180x$1?');
      }

      var price = variant.price;
      // Format price (Shopify product.json returns price in dollars as string)
      var priceFormatted = '$' + parseFloat(price).toFixed(2);

      html += '<div class="cart-upsells__item">';
      html += '  <a href="/products/' + product.handle + '" class="cart-upsells__image-link">';
      if (imageUrl) {
        html += '    <img src="' + imageUrl + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" class="cart-upsells__img" loading="lazy">';
      }
      html += '  </a>';
      html += '  <div class="cart-upsells__details">';
      html += '    <a href="/products/' + product.handle + '" class="cart-upsells__name">' + product.title + '</a>';
      html += '    <div class="cart-upsells__price">' + priceFormatted + '</div>';
      if (product.variants && product.variants.length > 1) {
        html += '    <select class="cart-upsells__variant" aria-label="Choose ' + (product.title || '').replace(/"/g, '&quot;') + '"' +
          ' style="display:block;width:100%;max-width:180px;margin-top:6px;padding:5px 6px;font-size:16px;line-height:1.2;border:1px solid #ccc;border-radius:4px;background:#fff;color:#111;">';
        product.variants.forEach(function(v) {
          var off = v.available === false;
          html += '<option value="' + v.id + '" data-price="$' + parseFloat(v.price).toFixed(2) + '"' +
            (off ? ' disabled' : '') + (v.id === variant.id ? ' selected' : '') + '>' + String(v.title).replace(/</g, '&lt;') + (off ? ' (sold out)' : '') + '</option>';
        });
        html += '    </select>';
      }
      html += '  </div>';
      html += '  <button type="button" class="cart-upsells__add" data-variant-id="' + variant.id + '" aria-label="Add ' + (product.title || '').replace(/"/g, '&quot;') + '">Add</button>';
      html += '</div>';
    });

    html += '</div></div>';
    container.innerHTML = html;
  }

  function loadCartDrawerUpsells() {
    var container = document.getElementById('CartDrawerUpsells');
    if (!container) return;

    getCartItems().then(function(cart) {
      if (!cart.items || cart.items.length === 0) {
        container.innerHTML = '';
        return;
      }

      var cartHandles = cart.items.map(function(item) { return item.handle; });

      // Get upsell handles from data attributes embedded in the page
      // We'll use the product page's upsell section data if available
      var upsellSection = document.querySelector('.belcopia-upsells');
      var handles = [];

      if (upsellSection) {
        var items = upsellSection.querySelectorAll('.belcopia-upsells__item[data-product-handle]');
        items.forEach(function(item) {
          var h = item.getAttribute('data-product-handle');
          if (h && cartHandles.indexOf(h) === -1) {
            handles.push(h);
          }
        });
      }

      // Also try to get upsells for cart items via product.json
      var fetchPromises = cartHandles.slice(0, 3).map(function(handle) {
        return getProductData(handle).catch(function() { return null; });
      });

      Promise.all(fetchPromises).then(function() {
        // If we have handles from the product page section, use those
        if (handles.length > 0) {
          var productPromises = handles.slice(0, 4).map(function(h) {
            return getProductData(h).catch(function() { return null; });
          });

          Promise.all(productPromises).then(function(products) {
            renderCartDrawerUpsells(
              products.filter(function(p) { return p !== null; }),
              cartHandles
            );
          });
        }
      });
    });
  }

  function initCartDrawerUpsells() {
    document.addEventListener('change', function(evt) {
      var sel = evt.target;
      if (!sel.classList || !sel.classList.contains('cart-upsells__variant')) return;
      var row = sel.closest('.cart-upsells__item');
      if (!row) return;
      var btn = row.querySelector('.cart-upsells__add');
      if (btn) btn.setAttribute('data-variant-id', sel.value);
      var opt = sel.options[sel.selectedIndex];
      var price = row.querySelector('.cart-upsells__price');
      if (price && opt && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
    });

    // Handle add-to-cart clicks inside the cart drawer upsells
    document.addEventListener('click', function(evt) {
      var btn = evt.target.closest('.cart-upsells__add');
      if (!btn) return;

      evt.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = '...';

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: 'form_type=product&id=' + variantId + '&quantity=1'
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        btn.textContent = 'Added!';

        // Trigger cart rebuild
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data, addToCartBtn: btn }
        }));

        // Refresh upsells after a short delay (let cart rebuild first)
        setTimeout(function() {
          loadCartDrawerUpsells();
        }, 500);
      })
      .catch(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      });
    });

    // Load upsells whenever cart drawer opens
    document.addEventListener('ajaxProduct:added', function() {
      setTimeout(loadCartDrawerUpsells, 300);
    });
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initProductPageUpsells();
      initCartDrawerUpsells();
    });
  } else {
    initProductPageUpsells();
    initCartDrawerUpsells();
  }

})();
